import React from 'react';
import axios from 'axios';

class Http extends React.Component {
	constructor(props) {
		super(props);

		this.instance = axios.create({
			baseURL: import.meta.env.VITE_BASE_URL,
			timeout: 10000,
			httpVersion: 2,
			// headers: { 'api-token': '56dd0ee1-31e7-4501-b760-80ea8d2b2e74' },
		});

		this.logoutCallback = null;

		this.instance.interceptors.response.use(
			response => {
				// console.log("INTER", response);
				if (response?.data?.code == 91) {
					console.log('ERROR LOGIN');
					if (this?.logoutCallback) {
						this.logoutCallback();
					}
				}
				return response;
			},
			error => {},
		);

		if (typeof window !== 'undefined') {
			const token = localStorage.getItem('token');
			if (token) {
				this.addToken(token);
			}
		}
	}

	setLogout(logoutCallback) {
		// console.log("eqweqweqw", logoutCallback);
		this.logoutCallback = logoutCallback;
	}

	get(url, args) {
		return this.instance.get(url, { params: args });
	}

	post(url, args) {
		return this.instance.post(url, args, {
			// headers: {
			//   "Content-Type": "multipart/form-data",
			// }
		});
	}

	put(url, args) {
		return this.instance.put(url, args, {
			// headers: {
			//   "Content-Type": "multipart/form-data",
			// }
		});
	}

	delete(url, args) {
		return this.instance.delete(url, args);
	}

	addToken(token) {
		// console.log('addToken', token)
		this.instance.defaults.headers.common['Authentication'] = token;
	}

	removeToken() {
		this.instance.defaults.headers.common['Authentication'] = '';
	}
}

const http = new Http();

export default http;
